<template>
  <div class="conversations__empty">
    <span class="conversations__empty-message">{{ this.text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      required: true,
      type: String,
    },
  },
};
</script>
